import React, { useState } from "react";
import { CommonButton } from "../../Input";
import DataTable from "../../table/DataTable";
import CreateBeneficiaryModal from "../../Beneficiaries/CreateBeneficiaryModal";
import BeneficiaryDetailsModal from "../../Beneficiaries/BeneficiaryDetailsModal";
import { Eye, Edit } from "lucide-react";

const BeneficiaryTab = ({ beneficiaries }) => {
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);

  const defaultBeneficiaries = [
    {
      id: "8376",
      name: "SparkMinds",
      contactNo: "+65 1234 567 890",
      receiverType: "Individual",
      relationship: "Business partner",
      bank: "OMNIPAY, INC.",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "06/03/2026\n18:37:48",
      status: "Approved",
      details: {
        country: "Singapore",
        currency: "SGD",
        relationship: "Business partner",
        idType: "NRIC",
        idNumber: "S1234567A",
        idExpiredDate: "12/12/2030",
        dob: "01/01/1990",
        firstName: "Spark",
        lastName: "Minds",
        contactNumber: "+65 1234 567 890",
        address: "123 Tech Park",
        city: "Singapore",
        state: "Singapore",
        postalCode: "123456",
        bankName: "OMNIPAY, INC.",
        accountNumber: "1234567890",
        accountType: "Savings",
        bankAccountTitle: "SparkMinds Tech",
        ifscNumber: "IFSC12345",
        routingNumber: "ROUT7890",
        bsbNumber: "BSB456",
        branchCode: "BR01",
        branchName: "Central Branch",
        transitNumber: "TRANS777",
        sortCode: "SORT888",
        swiftCode: "SWIFT999",
        branchNumber: "BRN001",
        institutionNumber: "INST002",
        cashPickupLocation: "Ho Chi Minh City",
      },
    },
  ];

  const data =
    beneficiaries && beneficiaries.length > 0
      ? beneficiaries
      : defaultBeneficiaries;

  return (
    <div className="beneficiary-tab">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="text-black fw-bold mb-0">Beneficiaries</h5>
        <CommonButton
          onClick={() => {
            setSelectedBeneficiary(null);
            setShowModal(true);
          }}
        >
          Add
        </CommonButton>
      </div>
      <DataTable
        columns={[
          { label: "ID", key: "id" },
          { label: "Name", key: "name" },
          { label: "Contact No", key: "contactNo" },
          { label: "Receiver Type", key: "receiverType" },
          { label: "Relationship", key: "relationship" },
          { label: "Bank", key: "bank" },
          { label: "Correspondence Bank", key: "correspondenceBank" },
          { label: "Delivery Method", key: "deliveryMethod" },
          {
            label: "Created Date",
            key: "createdDate",
            cellStyle: () => ({ whiteSpace: "pre-line" }),
          },
          { label: "Status", key: "status" },
          {
            label: "Actions",
            key: "actions",
            render: (row) => (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-primary p-1 rounded d-flex align-items-center justify-content-center bg-opacity-10 border-0"
                  style={{ width: "32px", height: "32px" }}
                  onClick={() => {
                    setSelectedBeneficiary(row);
                    setShowModal(true);
                  }}
                >
                  <Edit size={16} />
                </button>
                <button
                  className="btn btn-outline-primary p-1 rounded d-flex align-items-center justify-content-center"
                  style={{ width: "32px", height: "32px" }}
                  onClick={() => {
                    setSelectedBeneficiary(row);
                    setShowDetailsModal(true);
                  }}
                >
                  <Eye size={16} />
                </button>
              </div>
            ),
          },
        ]}
        data={data}
      />
      <CreateBeneficiaryModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setSelectedBeneficiary(null);
        }}
        beneficiary={selectedBeneficiary}
      />
      <BeneficiaryDetailsModal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        beneficiary={selectedBeneficiary}
      />
    </div>
  );
};

export default BeneficiaryTab;
